export const DownloadType = {
  IMAGE: 'image',
  PICTURE: 'picture',
} as const

export type DownloadType = typeof DownloadType[keyof typeof DownloadType]
